(() => {
  'use strict';
  if (window.CgauCoastalControls) {window.CgauCoastalControls.scan(document); return;}
  const instances = new Map();
  function initialise(section) {
  if (instances.has(section)) return;
  const cleanups = [];
  const listen = (target,type,handler) => {if (!target) return; target.addEventListener(type,handler);cleanups.push(()=>target.removeEventListener(type,handler));};
  const scene = section.querySelector('.coast-scene');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const modes = [...document.querySelectorAll('[data-time]')];
  const pauseButton = section.querySelector('[data-motion-toggle]');
  const replayButton = section.querySelector('[data-replay-light]');
  const form = document.querySelector('[data-preview-form]');
  let night = 0, target = 0, startValue = 0, tween = 1, mode = 'cycle';
  let phase = .04, startPhase = .04, targetPhase = .04;
  let userPaused = false, motionOverride = false, ambientPaused = section.dataset.cgauMotionPaused === 'true', visible = true, suspended = false;
  const reduced = () => reduce.matches && !motionOverride;
  const paused = () => userPaused || reduced();
  let lampAge = 0, lampStarted = false, cycleTime = 0, lamp = 0, flare = 0;
  let raf = 0, last = 0;
  const smooth = x => x * x * (3 - 2 * x);
  const STARTUP_DURATION = 3.65;
  const CYCLE_DURATION = 64;
  const IGNITION_NIGHT = .58;
  const PHASES = {sunrise:.04,day:.25,dusk:.455,twilight:.53,night:.74};
  const COLOUR_STOPS = [[0,.15,.70],[.02,.72,.42],[.04,1,.20],[.065,.75,.04],
    [.10,.10,0],[.135,0,0],[.32,0,0],[.37,.18,0],[.41,.75,.10],[.455,1,.32],
    [.49,.62,.85],[.53,.08,1],[.595,0,.34],[.68,0,0],[.88,0,0],
    [.95,0,.18],[.985,.06,.58],[1,.15,.70]];
  function coloursAt(p) {
    for(let i=1;i<COLOUR_STOPS.length;i++) {
      const a=COLOUR_STOPS[i-1],b=COLOUR_STOPS[i];
      if(p<=b[0]) {
        const t=smooth(Math.max(0,Math.min(1,(p-a[0])/(b[0]-a[0]))));
        return {warm:a[1]+(b[1]-a[1])*t,twilight:a[2]+(b[2]-a[2])*t};
      }
    }
    return {warm:.15,twilight:.70};
  }
  function nightAt(value) {
    const stops=[[0,1],[.02,.60],[.04,.28],[.07,.06],[.10,0],
      [.40,0],[.455,.26],[.49,.50],[.53,.70],[.59,1],[1,1]];
    for(let i=1;i<stops.length;i++) {
      const a=stops[i-1],b=stops[i];
      if(value<=b[0]) {
        const t=smooth(Math.max(0,Math.min(1,(value-a[0])/(b[0]-a[0]))));
        return a[1]+(b[1]-a[1])*t;
      }
    }
    return 1;
  }
  // Each part behaves like its own fluorescent circuit: short strikes,
  // phosphor decay, missed starts, then a stable arc. Values are deterministic.
  const TUBES = {
    shield: [[0,0],[.12,0],[.14,.82],[.20,.66],[.36,.04],[.62,.04],[.64,1],[.73,.86],[.93,.16],[1.25,.16],[1.27,.94],[1.36,.76],[1.48,.42],[1.61,1],[3.65,1]],
    title: [[0,0],[.20,0],[.22,1],[.29,.58],[.43,.02],[.65,.02],[.68,.42],[.85,.07],[1.13,.07],[1.15,.96],[1.27,.87],[1.48,.14],[1.79,.14],[1.81,1],[1.98,.44],[2.15,1],[3.65,1]],
    name: [[0,0],[.28,0],[.30,.86],[.37,.65],[.52,.025],[.72,.025],[.74,1],[.82,.92],[1.02,.08],[1.40,.08],[1.42,1],[1.49,.82],[1.68,.06],[1.92,.06],[1.94,.62],[2.14,.08],[2.46,.08],[2.48,1],[2.58,.94],[2.74,.58],[2.98,1],[3.65,1]],
    byline: [[0,0],[.35,0],[.38,.35],[.56,.04],[.78,.04],[.81,.52],[1.05,.03],[1.45,.03],[1.47,.72],[1.69,.09],[2.10,.09],[2.13,.67],[2.34,.12],[2.90,.12],[2.93,.96],[3.10,.70],[3.42,1],[3.65,1]]
  };
  function tubeValue(track, time) {
    for (let i = 1; i < track.length; i++) {
      if (time <= track[i][0]) {
        const [ta, a] = track[i - 1], [tb, b] = track[i];
        const u = Math.max(0, Math.min(1, (time - ta) / (tb - ta)));
        // Strikes catch quickly. Falling values trail as the phosphor cools.
        return a + (b - a) * (b >= a ? u : 1 - Math.pow(1 - u, 2));
      }
    }
    return track[track.length - 1][1];
  }
  const emit = (type, detail) => scene.dispatchEvent(new CustomEvent(type, {detail}));
  function setNight(value, nextPhase = phase) {
    night = Math.max(0, Math.min(1, value));
    phase = Math.max(0, Math.min(1, nextPhase));
    section.style.setProperty('--night', night.toFixed(4));
    scene.style.setProperty('--night', night.toFixed(4));
    section.dataset.light = night > .53 ? 'night' : 'day';
    section.dataset.night = night.toFixed(4);
    scene.dataset.night = night.toFixed(4);
    scene.dataset.phase = phase.toFixed(5);
    scene.dataset.coastMode = mode;
    section.dataset.phase = phase.toFixed(5);
    const {warm,twilight}=coloursAt(phase);
    scene.dataset.warm=warm.toFixed(4);scene.dataset.twilight=twilight.toFixed(4);
    section.style.setProperty('--coast-warm',warm.toFixed(4));
    section.style.setProperty('--coast-twilight',twilight.toFixed(4));
    const label = phase < .10 ? 'Sunrise' : phase < .33 ? 'Daylight' : phase < .49 ? 'Sunset' : phase < .62 ? 'Violet twilight' : 'Night';
    const phaseLabel = document.querySelector('[data-cycle-label]');
    if (phaseLabel && phaseLabel.textContent !== label) phaseLabel.textContent = label;
    emit('coast:time', {night,phase,mode,warm,twilight,still:paused()});
  }
  function paintLamp() {
    let segments = {shield:0,title:0,name:0,byline:0};
    if (night < .5) {lampStarted = false; lampAge = 0;}
    if (reduced()) {
      const on = night >= IGNITION_NIGHT ? 1 : 0;
      segments = {shield:on,title:on,name:on,byline:on};
      lampStarted = Boolean(on); lampAge = on ? STARTUP_DURATION : 0;
    } else if (night >= IGNITION_NIGHT || lampStarted) {
      if (!lampStarted) {lampStarted = true; lampAge = 0;}
      for (const [key, track] of Object.entries(TUBES)) segments[key] = tubeValue(track, lampAge);
    }
    lamp = segments.shield * .23 + segments.title * .14 + segments.name * .51 + segments.byline * .12;
    const strongest = Math.max(segments.shield, segments.name);
    // Three distinct ballast strikes bloom locally across the sign. Their
    // soft decay keeps the ignition legible instead of strobing the whole card.
    const strikeAt = at => {
      const d=lampAge-at;
      return d<-.065 ? 0 : d<0 ? smooth((d+.065)/.065) : Math.exp(-d/.18);
    };
    const strike = reduced() || !lampStarted || lampAge>=STARTUP_DURATION ? 0 :
      Math.max(strikeAt(.64),strikeAt(1.81),strikeAt(2.98));
    flare = reduced() ? 0 : lampAge < STARTUP_DURATION ? Math.max(strike*1.55,Math.max(0,strongest-.78)*.9) : .08;
    for (const [key, value] of Object.entries(segments)) section.style.setProperty('--lamp-' + key, value.toFixed(4));
    section.style.setProperty('--lamp', lamp.toFixed(4));
    section.style.setProperty('--strike',strike.toFixed(4));
    section.style.setProperty('--flare', (flare * lamp).toFixed(4));
    section.style.setProperty('--ghost', Math.max(0, flare - .20).toFixed(4));
    section.dataset.lamp = lamp.toFixed(3);
    section.dataset.lampPhase = !lampStarted ? 'off' : lampAge < STARTUP_DURATION && !reduced() ? 'starting' : 'steady';
    section.dataset.lampTime = lampAge.toFixed(3);
    // Weather shares the actual ballast timeline, including replay and pause.
    emit('coast:lamp', {age:lampAge,strike,lamp,starting:lampStarted && lampAge<STARTUP_DURATION,
      reduced:reduced()});
  }
  function active() {return !suspended && !document.hidden && visible && !paused() && !ambientPaused;}
  function needFrame() {return active() && (mode === 'cycle' || tween < 1 || (lampStarted && lampAge < STARTUP_DURATION));}
  function schedule() {if (!raf && needFrame()) {last = 0; raf = requestAnimationFrame(frame);}}
  function frame(now) {
    raf = 0;
    if (!active()) return;
    const dt = last ? Math.min((now - last) / 1000, .08) : 0;
    last = now;
    if (mode === 'cycle') {
      cycleTime = (cycleTime + dt) % CYCLE_DURATION;
      const next = cycleTime / CYCLE_DURATION;
      setNight(nightAt(next),next);
    } else if (tween < 1) {
      tween = Math.min(1, tween + dt / 2.6);
      setNight(startValue + (target - startValue) * smooth(tween),startPhase + (targetPhase - startPhase) * smooth(tween));
    }
    if (lampStarted) lampAge += dt;
    paintLamp();
    if (needFrame()) raf = requestAnimationFrame(frame);
  }
  function updatePause(userInitiated = false) {
    if (pauseButton) {
      pauseButton.setAttribute('aria-pressed', String(paused()));
      pauseButton.innerHTML = paused() ? '<span aria-hidden="true">▶</span> Play scenery' : '<span aria-hidden="true">Ⅱ</span> Pause scenery';
    }
    section.dataset.paused = String(paused());
    emit('coast:pause', {paused:userPaused, userInitiated});
    if (!active()) {cancelAnimationFrame(raf); raf = 0; last = 0;}
    else schedule();
  }
  function selectMode(value, immediate = false) {
    mode = ['sunrise','day','dusk','twilight','night','cycle'].includes(value) ? value : 'cycle';
    section.dataset.mode = mode;
    modes.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.time === mode)));
    if (mode === 'cycle') {
      cycleTime = phase * CYCLE_DURATION;
      setNight(nightAt(phase),phase);
      if (phase < .1) {lampStarted = night >= IGNITION_NIGHT; lampAge = STARTUP_DURATION;}
      if (reduced()) {setNight(0,PHASES.day);cycleTime = PHASES.day * CYCLE_DURATION;}
    } else {
      targetPhase = PHASES[mode];
      target = nightAt(targetPhase);
      startValue = night;
      startPhase = phase;
      tween = (immediate || reduced() || paused()) ? 1 : 0;
      if (tween === 1) setNight(target,targetPhase);
    }
    if (paused()) {lampAge = STARTUP_DURATION; lampStarted = night >= IGNITION_NIGHT;}
    paintLamp();
    schedule();
  }
  modes.forEach(button => listen(button,'click', () => selectMode(button.dataset.time)));
  listen(pauseButton,'click', () => {if (paused()) {userPaused = false; motionOverride = true;} else {userPaused = true;} updatePause(true);});
  listen(replayButton,'click', () => {
    selectMode('night', true);
    lampStarted = true; lampAge = 0;
    if (!reduce.matches) {userPaused = false; motionOverride = true;}
    paintLamp(); updatePause(!reduce.matches); schedule();
  });
  listen(form,'submit', event => {
    event.preventDefault();
    form.querySelector('[role="status"]').hidden = false;
    // The local review never stores or transmits the address.
    form.querySelector('input[type="email"]').value = '';
  });
  const observer = new IntersectionObserver(entries => {visible = entries[0].isIntersecting; updatePause();}, {threshold:0});
  observer.observe(section);
  listen(document,'visibilitychange', () => updatePause());
  listen(window,'pagehide', () => {suspended = true; updatePause();});
  listen(window,'pageshow', () => {suspended = false; updatePause();});
  listen(reduce,'change', () => {motionOverride = false; if (reduce.matches) {tween = 1; setNight(mode === 'cycle' ? night : target,mode === 'cycle' ? phase : targetPhase); paintLamp();} updatePause();});
  const ambientChange = event => {ambientPaused = Boolean(event.detail?.paused); updatePause();};
  listen(section,'cgau:ambient-motion-change', ambientChange);
  listen(window,'cgau:ambient-motion-change', event => {if (event.target === window) ambientChange(event);});
  selectMode(new URLSearchParams(location.search).get('time') || section.dataset.defaultMode || 'cycle', true);
  updatePause();
  instances.set(section,()=>{suspended=true;cancelAnimationFrame(raf);raf=0;observer.disconnect();cleanups.forEach(remove=>remove());instances.delete(section);});
  }
  function scan(scope) {scope.querySelectorAll('[data-coastal-section]').forEach(initialise);}
  window.CgauCoastalControls = {scan};
  scan(document);
  document.addEventListener('shopify:section:load',()=>scan(document));
  document.addEventListener('shopify:section:unload',event=>{for(const [section,dispose] of instances)if(event.target.contains(section))dispose();});
})();
